import SnowflakeId from 'snowflake-id'


export default async function generateSnowflakeIDStrings(machineID, numberOfIDs = 1) {
  const snowflake = new SnowflakeId({
    mid: machineID,
  })

  const ids = []
  for (let i = 0; i < numberOfIDs; i++) {
    ids.push(snowflake.generate())
  }
  return ids
}
